import { ReactNode } from 'react'
import BackButton from '../BackButton/BackButton'
import { useSwipeBack } from '@/hooks/useSwipeBack'
import './PageHeader.css'

interface PageHeaderProps {
  /** 뒤로가기 버튼 클릭 핸들러 */
  onBack?: () => void
  /** 뒤로가기 버튼 표시 여부 */
  showBack?: boolean
  /** 헤더 제목 (선택사항) */
  title?: string | ReactNode
  /** 왼쪽 영역 커스텀 컨텐츠 */
  leftContent?: ReactNode
  /** 오른쪽 영역 액션 버튼들 */
  rightContent?: ReactNode
  /** 추가 CSS 클래스 */
  className?: string
  /** 제목 중앙 정렬 + 큰 제목 스타일 (가이드/사용자정보/설정 페이지용) */
  centerTitle?: boolean
  /** 제목 색상 변형 (헤더 아이콘과 맞춤) */
  titleVariant?: 'guide' | 'user' | 'settings'
}

/**
 * 페이지 헤더 공통 컴포넌트
 * 뒤로가기 버튼, 제목, 액션 버튼을 포함하는 일관된 헤더 레이아웃 제공.
 * onBack이 있으면 왼쪽 가장자리 스와이프 제스처로도 뒤로가기 가능.
 */
function PageHeader({
  onBack,
  showBack = true,
  title,
  leftContent,
  rightContent,
  className = '',
  centerTitle = false,
  titleVariant,
}: PageHeaderProps) {
  useSwipeBack(onBack)

  const titleClass = [
    'page-header__title',
    centerTitle && 'page-header__title--center',
    titleVariant && `page-header__title--${titleVariant}`,
  ].filter(Boolean).join(' ')

  return (
    <div className={`page-header ${centerTitle ? 'page-header--center' : ''} ${className}`}>
      <div className="page-header__left">
        {showBack && onBack && <BackButton onClick={onBack} />}
        {leftContent}
        {title && <h2 className={titleClass}>{title}</h2>}
      </div>
      {rightContent && (
        <div className="page-header__right">{rightContent}</div>
      )}
    </div>
  )
}

export default PageHeader

